







import { Component, Prop, Vue } from 'vue-property-decorator';


@Component({})
export default class Placeholder extends Vue {
  @Prop({required: true})
  public placeholder!: string;

}
